import { render, staticRenderFns } from "./officialAccAuth.vue?vue&type=template&id=d2a0e0ae&scoped=true&"
import script from "./officialAccAuth.vue?vue&type=script&lang=js&"
export * from "./officialAccAuth.vue?vue&type=script&lang=js&"
import style0 from "./officialAccAuth.vue?vue&type=style&index=0&id=d2a0e0ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a0e0ae",
  null
  
)

export default component.exports